import { Url } from '../shared/Url';
import Post from '../shared/Post';
import { cookieData } from '../funciones/ConsultaUser';
import { consultaUser } from './PefilFunction';

import { requerido, numero } from './Validaciones';

export const ConsultVerificaciones = (pag, limite, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            limite: limite,
            pag: pag
        }

        Post(`${Url}ConsultVerificaciones`, Content, (resp) => {
            let data = JSON.parse(resp)
            respuesta (data.listado)
        });
    });
}

export const CantidadVerificaciones = (respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
        }

        Post(`${Url}CantidadVerificaciones`, Content, (resp) => {
            let data = JSON.parse(resp)
            respuesta (data[0])
        });
    });
}

export const ConsultVerificacionesInd = (id, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            id: id
        }

        Post(`${Url}ConsultVerificacionesInd`, Content, (resp) => {
            let data = JSON.parse(resp)
            respuesta (data.listado)
        });
    });
}

export const ConsultMetodos = (respuesta) => {
    Post(`${Url}ConsultMetodos`, "", (resp) => {
        let data = JSON.parse(resp)
        let contenido = []
        for (let i in data[0]) {
            contenido.push({
                value: data[0][i].id, label: data[0][i].nombre
            })
        }
        respuesta (contenido)
    }); 
}

export const AceptarTransaccion = (id, factura, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            id: id,
            factura: factura
        }

        Post(`${Url}AprobarTrans`, Content, (resp) => {
            let data = JSON.parse(resp)
            respuesta (data)
        });
    });
}

export const NoAceptarTransaccion = (id, motivo, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            id: id,
            motivo: motivo
        }

        Post(`${Url}NoAprobarTrans`, Content, (resp) => {
            let data = JSON.parse(resp)
            respuesta (data)
        });
    });
}

export const ConsultCambio = (respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1]
        }

        Post(`${Url}ConsultCambio`, Content, (resp) => {
            let data = JSON.parse(resp)
            respuesta (data[0])
        });
    });
}

export const ConsultEstDisp = (respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
        }

        Post(`${Url}ConsultEstDisp`, Content, (resp) => {
            let data = JSON.parse(resp)
            respuesta (data[0])
        });
    });
}

export const AperturaCuenta = (est, saldo, deuda, respuesta) => {
    let errores = 0;
    let nameErr = [];
    let states = [];

    let mensaje = [{
        status: "error",
        mensaje: "No se pudo guardar la información. Revisa los errores encontrados para continuar"
    }];

    /* Validaciones */
    requerido(errores, est, "", "", "", "No se ha seleccionado el estudiante", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    if (saldo === "" &&  deuda === ""){
        errores ++;
        nameErr.push("Debes agregar al menos un monto para continuar")
    }

    numero(errores, saldo, "", "", "El campo Saldo Inicial debe contener solo números", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    numero(errores, deuda, "", "", "El campo Deuda Inicial debe contener solo números", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    if (errores === 0){
        cookieData((cookie) => {
            let Content = {
                uId: cookie[1],
                est: est,
                saldo: saldo,
                deuda: deuda
            }
    
            Post(`${Url}AperturarCuenta`, Content, (resp) => {
                mensaje = [{
                    status: "info",
                    mensaje: "Se ha aperturado correctamente la cuenta del estudiante"
                }];

                respuesta([states, mensaje, errores, nameErr])
            });
        });
    }else{
        respuesta([states, mensaje, errores, nameErr])
    }
}

export const AgregarCobro = (idEst, concepto, valor, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            idEst: idEst,
            concepto: concepto,
            valor: valor
        }

        Post(`${Url}AgregarCobro`, Content, (resp) => {
            let data = JSON.parse(resp);
            respuesta(data)
        });
    });
}

export const Precios = (consulta, respuesta) => {
    consultaUser((estudiante) => {
        let Content = {
            id: estudiante,
            tipo: consulta
        }

        Post(`${Url}ConsultaPrecios`, Content, (resp) => {
            let data = JSON.parse(resp);
            let Contenido = {
                uc: data.ValorUc,
                bs: data.ValorBs
            }
            
            respuesta(Contenido)
        });
    });
}

export const EstudiantesxSecc = (seccion, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            seccion: seccion
        }

        Post(`${Url}EstudiantesxSecc`, Content, (resp) => {
            let data = JSON.parse(resp);
            respuesta(data[0])
        });
    });
}

export const ConsultRecibos = (pag, limite, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            limite: limite,
            pag: pag
        }

        Post(`${Url}ConsultRecibos`, Content, (resp) => {
            let data = JSON.parse(resp)
            respuesta (data[0])
        });
    });
}

export const BuequedaReciboInd = (pag, limite, string, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            limite: limite,
            pag: pag,
            strings: string
        }

        Post(`${Url}BuequedaReciboInd`, Content, (resp) => {
            let data = JSON.parse(resp)
            respuesta (data[0])
        });
    });
}

export const CantidadRecibos = (respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
        }

        Post(`${Url}CantidadRecibos`, Content, (resp) => {
            let data = JSON.parse(resp)
            respuesta (data[0])
        });
    });
}

export const DelRecibo = (id, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            id: id
        }

        Post(`${Url}delRecibo`, Content, (resp) => {
            let data = JSON.parse(resp)
            respuesta (data)
        });
    });
}


// WEBPACK FOOTER //
// ./src/funciones/AdministracionFunction.jsx